<template>
  <div class="caseList">
    <aboutNav></aboutNav>
    <div class="container">
      <img
        style="display: block; width: 100%"
        src="../../assets/images/anli.jpg"
        alt=""
      />
    </div>
    <!-- <div class="swiper-box">
      <swiper :options="swiperOptionTop" class="gallery-top" ref="swiperTop">
        <swiper-slide v-for="(item, index) in swiperData" :key="index">
          <img :src="item.content_value" alt="多对多物联平台" />
          <div class="title" v-if="item.description">
            {{ item.description }}
          </div>
        </swiper-slide>

        <div
          class="swiper-button-next swiper-button-white"
          slot="button-next"
        ></div>
        <div
          class="swiper-button-prev swiper-button-white"
          slot="button-prev"
        ></div>
      </swiper>
      <swiper
        :options="swiperOptionThumbs"
        class="gallery-thumbs"
        ref="swiperThumbs"
      >
        <swiper-slide v-for="(item, index) in swiperData" :key="index">
          <img :src="item.content_value" alt="多对多物联平台" />
        </swiper-slide>
      </swiper>
    </div> -->
  </div>
</template>
<script>
import aboutNav from "./aboutNav";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import cgal1 from "../../assets/images/about/cgal1.png";
import cgal2 from "../../assets/images/about/cgal2.png";
import cgal3 from "../../assets/images/about/cgal3.png";
import cgal4 from "../../assets/images/about/cgal4.png";
import cgal5 from "../../assets/images/about/cgal5.png";
import cgal6 from "../../assets/images/about/cgal6.png";
import cgal7 from "../../assets/images/about/cgal7.png";
import cgal8 from "../../assets/images/about/cgal8.png";
import cgal9 from "../../assets/images/about/cgal9.png";
import cgal10 from "../../assets/images/about/cgal10.png";
import cgal11 from "../../assets/images/about/cgal11.png";
import cgal12 from "../../assets/images/about/cgal12.png";
import cgal13 from "../../assets/images/about/cgal13.png";
import cgal14 from "../../assets/images/about/cgal14.png";
import cgal15 from "../../assets/images/about/cgal15.png";
import cgal16 from "../../assets/images/about/cgal16.png";
import cgal17 from "../../assets/images/about/cgal17.png";

export default {
  name: "successCase",
  components: {
    aboutNav,
    swiper,
    swiperSlide,
  },
  metaInfo: {
    meta: [
      {
        name: "keywords",
        content:
          "多对多物联集团、银发经济、人口老龄化、心脑血管、慢性疾病、血压高、血糖、体脂管理、中医馆、养生馆、健康管理师、科学工作站、公益行动、老年产品目录、健康机构、客户管理、拓客、医保社保、养生保健、远程管理",
      },
      {
        name: "discription",
        content:
          "多对多物联集团是一家深耕于大健康领域多年的健康管理数智服务商，是华为战略合作伙伴，华为健康数据与多对多实现互联互通。多对多健康管理 SaaS 系统和健康管理拓客赢利AI解决方案，为用户建立健康档案，提供健康 AI 管理。业务涵盖医院、养老机构、社区中心、康养中心、养老院、中医馆、养生馆等。针对人口老龄化现状和银发经济趋势，多对多加入了科学健康指导工作站，百城千镇家庭防大病数智服务健康公益行动办公室。开放专业健康管理师进驻，实现合作加盟共赢。",
      },
    ],
  },
  data() {
    return {
      swiperOptionTop: {
        slidesPerView: 1,
        initialSlide: 0,
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        // loop: true,
        // direction: "horizontal"
      },
      swiperOptionThumbs: {
        spaceBetween: 20,
        centeredSlides: false,
        slidesPerView: "auto",
        touchRatio: 0.2,
        slideToClickedSlide: true,
      },
      swiperData: [
        {
          imgUrl: cgal1,
          title: "清远英德-宏泰嘉园2019年10月2日开盘1小时40分钟，劲销85套",
        },
        {
          imgUrl: cgal2,
          title: "清远英德-宏泰嘉园：营销体验中心",
        },
        {
          imgUrl: cgal3,
          title: "清远英德-宏泰嘉园：营销体验中心-简易场景体验",
        },
        {
          imgUrl: cgal4,
          title: "广州增城丰盛101广场丰盛星苑豪装项目",
        },
        {
          imgUrl: cgal5,
          title:
            "康桥水岸-智慧小区：将实现与龙江镇文华智慧社区、业主及商铺进行智能物联",
        },
        {
          imgUrl: cgal6,
          title: "梅州冠华城-梅州首个第五代智慧地产",
        },
        {
          imgUrl: cgal7,
          title:
            "广东德怡-产业园智能化升级：通过实现园区通道智能化升级，后期可接入智慧社区及周边商圈",
        },
        {
          imgUrl: cgal8,
          title: "佛山利保·米兰汇：家具产业综合体",
        },
        {
          imgUrl: cgal9,
          title:
            "2019年5月，“宏泰嘉园AI生活新智慧”清远首个第五代智慧地产落地签约仪式圆满礼成",
        },
        {
          imgUrl: cgal10,
          title: "2019年5月，多对多签约智慧文华社区项目",
        },
        {
          imgUrl: cgal11,
          title: "2019年6月，全球共德与多对多物联跨界合作！",
        },
        {
          imgUrl: cgal12,
          title: "2019年7月，第五代智慧地产闪耀广州白云BNI盛荟",
        },
        {
          imgUrl: cgal13,
          title: "2019年7月，多对多物联携手中国移动---5G+物联顺德会师",
        },
        {
          imgUrl: cgal14,
          title: "2019年7月，顺德首批智慧社区迎来政府专家组调研",
        },
        {
          imgUrl: cgal15,
          title: "2019年8月，多对多物联与伸豪文旅达成合作",
        },
        {
          imgUrl: cgal16,
          title:
            "2019年9月，中住数据-住房城乡建设云平台与多对多物联平台在北京正式签署“智慧住建 美好生活”年度战略发展合作协议",
        },
        {
          imgUrl: cgal17,
          title: "2019年10月3日，梅州首个第五代智慧地产定址“冠华城”",
        },
      ],
    };
  },
  created() {
    if (this.$route.query.name == "why") {
      this.$nextTick(() => {
        setTimeout(() => {
          var height = document.getElementById("header").clientHeight;
          document.documentElement.scrollTop = height; //不需要加单位
        }, 10);
      });
    }
    // 获取案例分享轮播图
    this.getSuccessfulCasesImg();
  },
  mounted() {
    this.$nextTick(() => {
      const swiperTop = this.$refs.swiperTop.swiper;
      const swiperThumbs = this.$refs.swiperThumbs.swiper;
      swiperTop.controller.control = swiperThumbs;
      swiperThumbs.controller.control = swiperTop;
    });
  },
  methods: {
    // 获取案例分享轮播图
    getSuccessfulCasesImg() {
      this.sendHttp({
        method: "post",
        url: `${this.baseUrl}/index/getplate`,
        data: {
          alias: "example",
          webpage: "www",
          limit: 30,
        },
      }).then((res) => {
        if (res.code == "0") {
          console.log(res);
          this.swiperData = res.data.image;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.caseList {
  box-shadow: 0 10px 10px -3px #efefef;
}

.swiper-box {
  padding-bottom: 100px;

  @media (max-width: 576px) {
    padding-bottom: 50px;
  }
}

.swiper-button-next,
.swiper-button-prev {
  background-color: rgba(0, 0, 0, 0.2);
  background-size: 50%;
  border-radius: 5px;
  padding: 30px 20px;

  @media (max-width: 576px) {
    display: none;
  }
}

.swiper-container {
  width: 1000px !important;
  margin: 40px auto;
  background-color: #ffffff;

  @media (max-width: 1200px) {
    width: 85% !important;
  }

  @media (max-width: 576px) {
    width: 100% !important;
  }
}

.swiper-slide {
  background-size: cover;
  background-position: center;

  img {
    width: 100%;
    height: 100%;
  }
}

.gallery-top {
  height: 80% !important;
  width: 100%;

  .swiper-slide {
    box-shadow: #8d8e90 0px 0px 20px;
    position: relative;

    .title {
      font-weight: bold;
      color: #fff;
      text-align: center;
      letter-spacing: 2px;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 40px;
      line-height: 40px;
      background: rgba(0, 0, 0, 0.4);
    }
  }
}

.gallery-thumbs {
  box-sizing: border-box;
  padding: 10px 0;
}

.gallery-thumbs .swiper-slide {
  width: 20%;
  height: 100%;
}

.gallery-thumbs .swiper-slide-active {
  border: 2px solid #00cfc8;
  border-image: linear-gradient(#6679b7, #00cfc8) 30 30;
}
</style>



// WEBPACK FOOTER //
// src/pages/about/successCase.vue